import crud from '@/crud/index/index'
import resources from '../../resources'

export default {
  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/patient/favorite-list/index/resources/index.js